import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const DATEDIFF = () => {
  return (
    <CardSection id="DATEDIFF" title="DATEDIFF">
      <Paragraph>두 날짜 사이의 차이를 계산합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>DATEDIFF(DATETIME_1, DATETIME_2, INTERVAL)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME_1</b>은 시작하려는 날짜입니다.
          </Li>
          <Li>
            <b>DATETIME_2</b>는 종료하려는 날짜입니다.
          </Li>
          <Li>
            <b>INTERVAL</b> 은 반환하려는 간격 유형(분, 일, 연도 등)입니다.
            다음은 <b>INTERVAL</b> 값에 대해 인식되는 값 목록입니다.
            <Ul>
              <Li>Years</Li>
              <Li>Months</Li>
              <Li>Weeks</Li>
              <Li>Days</Li>
              <Li>Hours</Li>
              <Li>Minutes</Li>
              <Li>Seconds</Li>
              <Li>Millis</Li>
            </Ul>
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>
          DATEDIFF(`Date-Received (1)`, `Date-Received (2)`, "days")
        </Paragraph>
        <Img src="computeDatediff" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>DATETIME</b>은 날짜/시간 객체, 날짜/시간 객체를 포함하는
          열 또는 날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          <b>DATETIME_2</b>에 최신 날짜/시간 값을 사용하는 것이 좋습니다.{" "}
          <b>DATETIME_2</b> 값으로 <b>DATETIME_1</b>보다 빠른 날짜를 입력하면{" "}
          <b>DATEDIFF</b> 함수는 음수를 반환합니다.
        </Paragraph>
        <Paragraph>
          <b>DATEDIFF</b> 함수는 항상 결과를 가장 가까운 정수로 내림합니다. 예를
          들어 두 날짜의 차이가 3년 11개월인 경우 <b>DATEDIFF</b> 함수는 차이를
          3년으로 반환합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
